export default {
  name: "Curbside",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M28.25 17.91 26 17.58V7c0-1.16-.84-2-2-2h-8c-1.16 0-2 .84-2 2v5h-3.5a.99.99 0 0 0-.86.49l-2.78 4.63-4.08.91c-.45.1-.78.5-.78.97v5c0 1.16.84 2 2 2h2.35c.56 1.18 1.76 2 3.15 2s2.58-.82 3.15-2h6.7c.56 1.18 1.76 2 3.15 2s2.58-.82 3.15-2H28c1.16 0 2-.84 2-2v-4.1c0-.95-.72-1.78-1.75-1.99zM16 7h8v10.28l-1.34-.2-2.27-4.53a.988.988 0 0 0-.89-.55H16V7zM9.5 26c-.83 0-1.5-.67-1.5-1.5S8.67 23 9.5 23s1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5.5-2h-2.05c-.25-1.69-1.69-3-3.45-3s-3.2 1.31-3.45 3h-6.1c-.25-1.69-1.69-3-3.45-3s-3.2 1.31-3.45 3H4v-4.2l3.72-.83c.27-.06.5-.23.64-.46L11.07 14h7.82l2.22 4.45c.15.29.43.49.75.54l6.05.89c.06.01.09.04.1.02V24z",
  },
}
